<template>
    <div class="pt-1 pb-2 container-sm">
        <b-row v-if="document">
            <b-col md="12">
                <b-card class="mb-1" no-body>
                    <div class="card-header">
                        <div class="card-group-title">
                            <h3 class="mb-0">
                                {{ document.header ? document.header.title : $t('v4.User Guide') }}
                            </h3>
                            <p
                                v-if="document.header && document.header.description"
                                class="mt-2 mb-0"
                            >
                                {{ document.header.description || $t('v4.User Guide') }}
                            </p>
                        </div>
                    </div>
                </b-card>
                <app-collapse
                    type="margin"
                    v-for="(item, index) in document.contents"
                    :key="index"
                    :id="'guide' + index"
                >
                    <template v-if="item.lines.length > 0">
                        <app-collapse-item :title="item.title" :isVisible="true">
                            <div
                                v-for="(subItem, subIndex) in item.lines"
                                :key="subIndex"
                                class="mb-0 collapse-style"
                                v-html="subItem"
                            />
                        </app-collapse-item>
                    </template>
                    <template v-else>
                        <b-card no-body>
                            <div class="card-header">
                                <div class="card-group-title">
                                    <h4 class="mb-0">{{ item.title }}</h4>
                                </div>
                            </div>
                        </b-card>
                    </template>
                </app-collapse>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { getCurrentInstance, ref, onMounted } from '@vue/composition-api'
import axios from 'axios'

export default {
    components: {
        AppCollapse,
        AppCollapseItem
    },
    setup () {
        const vm = getCurrentInstance().proxy

        const document = ref(null)

        onMounted(async () => {
            if (vm.$route.query.path && vm.$route.query.path.length) {
                const { data } = await axios.get(`${process.env.VUE_APP_HYPER_V3_CONTENT}/${vm.$route.query.path}`)
                // 문서 확인하면서 수정할 때 필요하다.
                // const { data } = await axios.get(`//localhost:8080/temp.json`)
                document.value = data
            }
        })

        /* computed */
        const scrollTo = (index) => {
            window.scrollTo({ top: document.getElementById('content' + index).offsetTop + 50, behavior: 'smooth' })
        }

        return {
            // userGuide,
            document,
            scrollTo
        }
    }
}
</script>

<style>
.collapse-title {
    padding: 1.7rem !important;
    padding-bottom: 1.2rem !important;
}
</style>
